import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <header className="border-b-4 border-safety bg-carbon px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-85" data-mp="eiv62y7sfcld">
      <h1 className="text-[0.8rem] font-extrabold uppercase leading-tight tracking-wide text-mist sm:text-[1.05rem]" data-id="element-86" data-mp="9ll64omrvija">
        THE COMPLETE <span className="text-safety" data-id="element-87" data-mp="4jvvha3gp6vq">WORKPLACE SAFETY INSPECTION</span> SYSTEM
      </h1>
      <p className="mt-1 font-display text-[1.75rem] font-bold uppercase leading-[1.02] text-white sm:text-[2.8rem]" data-id="element-88" data-mp="127ef5fynvtei">
        STOP WALKING PAST THE RISK. <span className="text-safety" data-id="element-89" data-mp="sarsclmrys9u">START INSPECTING WITH A SYSTEM.</span>
      </p>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-90" data-mp="ncgk2fc4optq">
        Identify workplace hazards, conduct structured safety inspections, document findings,
        prioritize risks, assign corrective actions, and verify resolution—all in one organized
        inspection system.
      </p>

      <BoxImage className="mx-auto mt-2 max-w-[280px] sm:max-w-[370px]" data-id="element-91" data-mp="3j9u1d0dmvqmc" />

      <div className="mx-auto mt-2 max-w-md" data-id="element-92" data-mp="3o85af8w3tx3i">
        <CTAButton label="🚀 YES! I WANT MY SAFETY INSPECTION SYSTEM NOW" data-id="element-93" data-mp="3o6u71a6kmrcx" />
        <p className="mt-2 text-[0.68rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-94" data-mp="399jm7a81g94j">
          🛡️ 7-Day Money-Back Guarantee — Zero Risk
        </p>
      </div>
    </header>;
}